(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edp-top-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('edp-top-sellers')) {
    customElements.define('edp-top-sellers', class extends HTMLElement {
      connectedCallback() {
        this.onSubmit = async (event) => {
          const form = event.target.closest('.edp-bestsellers__form');
          if (!form) return;
          event.preventDefault();
          const button = form.querySelector('button[type="submit"]');
          if (button.disabled) return;
          const feedback = form.querySelector('.edp-bestsellers__feedback');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          feedback.hidden = true;
          try {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const body = new FormData(form);
            if (cart) {
              body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
              body.append('sections_url', window.location.pathname);
              cart.setActiveElement(button);
            }
            const response = await fetch(form.action + '.js', { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || feedback.dataset.error);
            feedback.textContent = feedback.dataset.added;
            feedback.hidden = false;
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'edp-top-sellers', productVariantId: body.get('id'), cartData: result });
            }
            if (cart) {
              cart.classList.remove('is-empty');
              cart.renderContents(result);
            } else {
              window.location.assign(form.action.replace(/\/add$/, ''));
            }
          } catch (error) {
            feedback.textContent = error.message || feedback.dataset.error;
            feedback.hidden = false;
          } finally {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        };
        this.onVariantChange = (event) => {
          if (!event.target.matches('.edp-bestsellers__variant select')) return;
          const option = event.target.selectedOptions[0];
          const card = event.target.closest('.edp-bestsellers__card');
          const button = card.querySelector('button[type="submit"]');
          card.querySelector('.edp-bestsellers__price').textContent = option.dataset.price;
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.add;
        };
        this.addEventListener('change', this.onVariantChange);
        this.addEventListener('submit', this.onSubmit);
        this.track = this.querySelector('.edp-bestsellers__track');
        this.controls = this.querySelector('.edp-bestsellers__controls');
        this.buttons = [...this.controls.querySelectorAll('button')];
        this.onScroll = () => this.updateControls();
        this.onClick = (event) => {
          const button = event.target.closest('button[data-direction]');
          if (!button) return;
          const card = this.track.querySelector('.edp-bestsellers__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.controls.addEventListener('click', this.onClick);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.track);
        this.updateControls();
      }
      updateControls() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = max < 2;
        this.buttons[0].disabled = this.track.scrollLeft < 2;
        this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onVariantChange);
        this.removeEventListener('submit', this.onSubmit);
        this.observer?.disconnect();
        this.controls?.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('scroll', this.onScroll);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
